import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../../Supabase/Config';
import './ForgetPassword.scss';

function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (!email) {
      setMessage('Please enter a valid email address.');
      setIsError(true);
      return;
    }

    try {
      await resetPassword(email);
      setMessage('Password reset email sent! Please check your inbox.');
      setIsError(false);
    } catch (error) {
      setMessage('Failed to send reset email. Please try again.');
      setIsError(true);
      console.error('Error sending password reset email:', error);
    }
  };

  return (
    <div className="ForgetPassword">
      <div className="block">
        <img className="back" src="/images/login.svg" alt="ForgetPassword" />
      </div>
      <div className="ForgetPasswordForm">
        <div className="title">
          <h3>
            <img src="/images/logo.svg" alt="logo" />
          </h3>
        </div>
        <div>
          <div className="form-group margin-top margin-top">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email to receive password reset"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <img src="/images/f1.svg" alt="img" />
          </div>

          <button
            className="ForgetPasswordBtn margin-top"
            onClick={handleResetPassword}
          >
            Reset Password
          </button>
          <p className={isError ? 'error-message' : 'success-message'}>
            {message}
          </p>
          <div className="or">
            <p>
              <span>Or </span>
            </p>
          </div>
          <button
            className="ForgetPasswordBtn"
            onClick={() => navigate('/login')}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
